<div [ngxSummernoteView]="(landingContent$ | async)" class="product-family-content"></div>
